import React from 'react';
import { useLocation } from 'react-router-dom';
import { useCoachContext } from '../../context/CoachContext';
import { useStudentContext } from '../../context/StudentContext';
import GlobalSearch from '../GlobalSearch';

const Header: React.FC = () => {
  const { pathname } = useLocation();
  const { isAddingCoach, handleBackFromAddCoach } = useCoachContext();
  const { isAddingStudent, handleBackFromAddStudent } = useStudentContext();

  const title = pathname === '/' || pathname.startsWith('/home')
    ? 'Dashboard'
    : pathname.startsWith('/coaches')
      ? (isAddingCoach ? 'Add New Coach' : 'Coaches')
      : pathname.startsWith('/students')
        ? (isAddingStudent ? 'Add New Student' : 'Students')
        : pathname.startsWith('/sessions')
          ? 'Sessions'
          : pathname.startsWith('/messages')
            ? 'Messages'
            : pathname.startsWith('/reviews')
              ? 'Reviews & Feedback'
              : pathname.startsWith('/reports')
                ? 'Reports & Concerns'
                : pathname.startsWith('/requests')
                  ? 'Student Requests'
                  : pathname.startsWith('/settings')
                    ? 'Settings'
                    : 'Admin Dashboard';

  const subtitle = pathname.startsWith('/coaches') && !isAddingCoach
    ? 'Manage your coaching team'
    : pathname.startsWith('/students') && !isAddingStudent
      ? 'Manage your students'
      : pathname.startsWith('/requests')
        ? 'Review and assign coaches to new students'
        : pathname.startsWith('/sessions')
          ? 'Monitor and manage coaching sessions'
          : pathname.startsWith('/reviews')
            ? 'Monitor and manage coaching sessions'
            : pathname.startsWith('/reports')
              ? 'Manage student concerns and issues'
              : pathname.startsWith('/settings')
                ? 'Manage your account settings and preferences'
                : '';

  return (
    <header className="w-full px-6 py-4 mb-1 flex items-center justify-between">
      <div className="flex items-center gap-3">
        {pathname.startsWith('/coaches') && isAddingCoach && (
          <button
            onClick={handleBackFromAddCoach}
            className="rounded-lg p-1.5 hover:bg-gray-100 transition-colors"
          >
            <svg
              className="h-5 w-5 text-gray-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
        )}
        {pathname.startsWith('/students') && isAddingStudent && (
          <button
            onClick={handleBackFromAddStudent}
            className="rounded-lg p-1.5 hover:bg-gray-100 transition-colors"
          >
            <svg
              className="h-5 w-5 text-gray-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
        )}
        <div className="flex flex-col">
          <h1 className="text-lg font-semibold text-gray-900">{title}</h1>
          {subtitle && <p className="text-xs text-gray-400 mt-0.5">{subtitle}</p>}
        </div>
      </div>

      <div className="flex items-center gap-3">
        <GlobalSearch />

        {/* <button
          type="button"
          aria-label="Calendar"
          className="h-10 w-10 inline-flex items-center justify-center cursor-pointer hover:bg-slate-50 rounded-lg transition"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 2V5" stroke="#667085" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16 2V5" stroke="#667085" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M3 9H21" stroke="#667085" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path
              d="M21 8.5V19C21 21 20 22 18 22H6C4 22 3 21 3 19V8.5C3 6.5 4 5.5 6 5.5H18C20 5.5 21 6.5 21 8.5Z"
              stroke="#667085"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        <button
          type="button"
          aria-label="Notifications"
          className="relative h-10 w-10 inline-flex items-center justify-center"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z"
              stroke="#667085"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13.73 21C13.5542 21.3031 13.3019 21.5547 12.9982 21.7295C12.6946 21.9044 12.3504 21.9965 12 21.9965C11.6496 21.9965 11.3054 21.9044 11.0018 21.7295C10.6982 21.5547 10.4458 21.3031 10.27 21"
              stroke="#667085"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>

          <span className="absolute top-2.5 right-2.5 h-2 w-2 rounded-full bg-red-500 ring-2 ring-white" aria-hidden />
        </button> */}

      </div>
    </header>
  );
};

export default Header;
